import React from 'react';
import avtarImg from '../../../assets/images/DietPlans/avtar.png';
import { Container } from 'reactstrap';

const Testimonial = ({data}) => {
    return(
        <Container className='plan-testimonials py-3 mb-4'>
            <div className='d-flex mb-2 align-items-center'>
                <div className='avtar-img justify-content-center align-items-center'>
                    <img src={data?.image} alt='' />
                </div>
                <div>
                    <h4 className='name mb-0'>{data?.name}</h4>
                    {/* <img src={avtarWeightImg} alt='' /> */}
                </div>
            </div>
            <div className='description'>
                {data?.description}
            </div>
        </Container>
    )
}

export default Testimonial;